import React from "react";
import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import Header1 from "../layout/header/header1";
import bannerImg from "../../images/banner/banner1.jpg";
import { Link } from "react-router-dom";

class BecomeOurTeachers extends React.Component {
    render() {
        const { t } = this.props;

        return (
            <>
                <Header1 />

                <div className="page-content">

                    {/* Banner */}
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("Header_Become_Our_Teachers")}</h1>
                            </div>
                        </div>
                    </div>
                
                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("Become_Our_Teachers_LinkHome")}</Link>
                                </li>
                                <li>{t("Become_Our_Teachers_Link")}</li>
                            </ul>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">

                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="job-post-markdown prose max-w-none" style={{ fontSize: "18px", lineHeight: "1.8" }}>
                                            <ReactMarkdown>{t("Job_Post_MD")}</ReactMarkdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(BecomeOurTeachers);
